import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-error500',
  templateUrl: './error500.component.html',
  styleUrls: ['./error500.component.scss']
})
export class Error500Component implements OnInit {

  autoRedirectTime : number = 10;

  constructor(private pageTitle: Title) { }

  ngOnInit() {
    this.pageTitle.setTitle('Error');
    window.scrollTo(0, 0);
    let internalSub = setInterval(() => {
      if (this.autoRedirectTime >=1) {
        this.autoRedirectTime -= 1;
      }else{
        window.location.href = '/';
      }
    }, 1000);
  }
}
